import React, { useEffect, useState } from "react";
import axiosInstance from "../utils/api";

export default function ListItems({ endpoint, title }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    loadItems();
  }, []);

  const loadItems = async () => {
    try {
      const res = await axiosInstance.get(`/${endpoint}`);
      setItems(res.data);
    } catch (err) {
      console.error(err);
      alert("Failed to load " + title);
    }
  };

  // ⭐ Add to Cart Function
  const addToCart = async (productId) => {
    try {
      const token = localStorage.getItem("accessToken");

      await axiosInstance.post(
        "/cart/add/",
        { product_id: productId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      alert("Added to cart 👍");
    } catch (err) {
      console.error(err);
      alert("Failed to add to cart");
    }
  };

  return (
    <div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(220px,1fr))",
          gap: 16,
        }}
      >
        {items.map((item) => (
          <div
            key={item.id}
            style={{
              border: "1px solid #ddd",
              padding: 12,
              borderRadius: 8,
            }}
          >
            <h4>{item.name}</h4>

            {item.image ? (
              <img
                src={`http://127.0.0.1:8000${item.image}`}
                alt={item.name}
                style={{
                  width: "100%",
                  height: 140,
                  objectFit: "contain",
                }}
              />
            ) : (
              <div
                style={{
                  width: "100%",
                  height: 140,
                  background: "#f2f2f2",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                No Image
              </div>
            )}

            <p>Price: ₹{item.selling_price ?? item.price ?? "—"}</p>

            {/* ⭐ Add to Cart Button */}
            <button
              onClick={() => addToCart(item.id)}
              style={{
                width: "100%",
                marginTop: 10,
                padding: "10px 0",
                background: "green",
                color: "white",
                borderRadius: 5,
                cursor: "pointer",
                border: "none",
                fontWeight: "bold",
              }}
            >
              Add to Cart
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
